import React, { useCallback, useEffect, useState } from 'react';
import { GenericTable } from 'components/common/GenericTable';
import { getAllAdjustmentTypes } from '_redux/services/adjustmentTypes.service';
import { editAdjustmentTypes } from '_redux/services/adjustmentTypes.service';
import { Toaster, toast } from 'react-hot-toast';
import { getAdjustmentTypesColumns } from 'utils/AdjustmentTypes';
import './adjustmentTypes.module.scss';
import SetUpAdjustments from 'components/SetUpAdjustments/SetUpAdjustments';

const AdjustmentTypes = ({ handleTabChange, tab, tabs }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState();
  const [isSetUpModalOpen, setisIsSetUpModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [updatedRow, setUpdatedRow] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const getAdjustmentTypesData = useCallback(async () => {
    try {
      const response = await getAllAdjustmentTypes(page, rowsPerPage);
      const total = response.total;
      setTotalData(total);

      setData(prevData => {
        const lastPage = Math.ceil(total / rowsPerPage) - 1;
        if (page === lastPage) {
          const remainingItems = total % rowsPerPage || rowsPerPage;
          return response.data.slice(0, remainingItems);
        }
        return response.data;
      });
    } catch (error) {
      console.error('Error fetching Adjustment Types:', error);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    getAdjustmentTypesData();
  }, [getAdjustmentTypesData]);

  const handleRowSelection = id => {
    setSelectedRows(prev =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
    setCheckedAll(false);
  };

  const handleValueChange = (id, field, value) => {
    setData(prevData =>
      prevData.map(row => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const handleModalOpen = () => {
    setisIsSetUpModalOpen(true);
  };

  const handleModalClose = () => {
    setisIsSetUpModalOpen(false);
  };

  const handleEditToggle = () => {
    setIsEditMode(prev => !prev);
  };
  const handelCancelEdit = () => {
    setIsEditMode(false);
    getAdjustmentTypesData();
    setIsDelete(false);
    setSelectedRows([]);
  };

  const handleSaveChanges = async () => {
    try {
      const newRow = await editAdjustmentTypes(
        updatedRow.id,
        updatedRow.valuesChanged
      );

      if (newRow.id) {
        toast.success('Row updated successfully!');
        handleEditToggle();
        getAdjustmentTypesData();
      }
    } catch (error) {
      toast.error(`${error}`);
    }
  };

  const handleUpdateRow = row => {
    setUpdatedRow(row);
  };

  const handleAllChecked = () => {
    const allIds = data?.map(row => row.id) || [];
    const allSelected =
      allIds.length > 0 && allIds.every(id => selectedRows.includes(id));

    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(allIds);
    }
  };

  const columns = getAdjustmentTypesColumns({
    data,
    selectedRows,
    setSelectedRows,
    checkedAll,
    setCheckedAll,
    handleAllChecked,
    handleRowSelection,
    handleValueChange,
    isEditMode,
    handleUpdateRow,
  });

  useEffect(() => {
    const allIds = data?.map(row => row.id) || [];
    const allSelected =
      allIds.length > 0 && allIds.every(id => selectedRows.includes(id));
    setCheckedAll(allSelected);

    if (selectedRows.length > 0) {
      setIsDelete(true);
    } else {
      setIsDelete(false);
    }
  }, [selectedRows, data]);

  return (
    <>
      <Toaster />
      <GenericTable
        title="Adjustment Types"
        refreshData={getAdjustmentTypesData}
        handleEditToggle={handleEditToggle}
        handleCancelEdit={handelCancelEdit}
        handleSaveChanges={handleSaveChanges}
        isEditMode={isEditMode}
        showEdit={true}
        fetchType="adjustmentsTypes"
        columns={columns}
        data={data}
        setData={setData}
        isAdjustmentTypes={true}
        handleModalOpen={handleModalOpen}
        pageConfig={{
          page,
          setPage,
          rowsPerPage,
          setRowsPerPage,
          totalRows: totalData,
        }}
        handleTabChange={handleTabChange}
        tab={tab}
        isTabs={true}
        tabs={tabs}
        isDelete={isDelete}
        ids={selectedRows}
        handleDeleted={handelCancelEdit}
      />

      {isSetUpModalOpen && (
        <SetUpAdjustments
          onClose={handleModalClose}
          open={isSetUpModalOpen}
          handleClose={handleModalClose}
          refreshData={getAdjustmentTypesData}
        />
      )}
    </>
  );
};

export default AdjustmentTypes;
